import { render } from "./DetailsLink.vue?vue&type=template&id=09d5b84b"
import script from "./DetailsLink.vue?vue&type=script&lang=ts"
export * from "./DetailsLink.vue?vue&type=script&lang=ts"
script.render = render

export default script